// extracted by mini-css-extract-plugin
module.exports = {"input-container":"_1W0pa","tag":"_2qTZB","remove":"_1BdGj","input":"_1sGNe"};